import React from 'react';
import request from '../../request';

export default class Bans extends React.Component {
  constructor() {
    super();
    this.state = { bans: [] };
  }

  async componentDidMount() {
    try {
      let bans = await request({ url: `admin/bans` });
      this.setState({ bans });
    } catch (e) {}
  }
  render() {
    let { bans, loading } = this.state;
    return (
      <div id="dashboard" style={{ opacity: loading ? 0.5 : 1 }}>
        <div id="head">
          <div id="title">Bans</div>
        </div>
        <table>
          <thead>
            <tr>
              <th className="scorer">IP Address</th>
              <th className="scorer">Type</th>
              <th className="scorer">Email(s)</th>
              <th className="scorer">Attempt Count</th>
              <th className="scorer">Action</th>
            </tr>
          </thead>
          <tbody>
            {bans.map((ban, index) => (
              <tr key={index}>
                <td className="scorer">{ban.ip}</td>
                <td className="scorer">{ban.type}</td>
                <td className="scorer">
                  {ban.emails ? ban.emails.join(',') : 'N/A'}
                </td>
                <td className="scorer">{ban.attempts || 'N/A'}</td>
                <td
                  className="actions"
                  onClick={async () => {
                    if (!window.confirm('Are you sure?')) return;
                    await request({
                      url: `admin/bans`,
                      body: { ip: ban.ip },
                      method: 'POST',
                    });
                    window.location.reload();
                  }}
                >
                  <button>Unban</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/bans/index.js